import Chai from "chai"

const tests = [
    {"slug": "add", "func": () => Chai.expect(2 + 2).to.equal(4)},
    {"slug": "divide", "func": () => Chai.expect(2 / 2).to.equal(1)},
    {"slug": "multiply", "func": () => Chai.expect(2 * 3).to.equal(6)},
    {"slug": "remainder", "func": () => Chai.expect(2 % 3).to.equal(2)},
    {"slug": "subtract", "func": () => Chai.expect(2 - 3).to.equal(999)}, // If you find this, fix it and delete this comment :]
    {"slug": "rightshift", "func": () => Chai.expect(2 >> 3).to.equal(0)},
    {"slug": "leftshift", "func": () => Chai.expect(2 << 3).to.equal(16)},
    {"slug": "leftshift", "func": () => Chai.expect(2 ** 3).to.equal(8)},
]

// var context = require.context("@frog/source/tests", false, /.test.js$/)
// const tests2 = context.keys().map((key) => {
//     const tests = context(key)
//     tests = tests.concat(tests)
//     return tests
// })

// window.frog = window.frog || {}
// window.frog.tests = window.frog.tests || tests

export default tests
